import moment from 'moment';
import { timeDifference } from '../../utils/suitableDate';
import { ORDER_COMPLETED_LABEL, PICKUP_STATUS_KEY, ORDER_FLOW_TYPE, ORDER_TYPE_DELIVERY, ORDER_PHASE_CONTACTING, ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL } from '../../constants';

export const updateTime = component => {
  const { item = {}, currentDate } = component.props;
  const { limit, datePreparationEnded, datePreparationStarted } = item;
  const differ = currentDate.diff(moment(datePreparationStarted), 'seconds');
  const { diff, diffTime } = timeDifference(currentDate, moment(datePreparationEnded));
  return { progress: (differ / limit) * 100, diff, diffTime };
};
export const getPaidStatus = (statusLabel, paymentType) => {
  if (statusLabel !== ORDER_COMPLETED_LABEL && paymentType !== 'stripe') {
    return 'Non payé';
  }
  if (paymentType === 'stripe') {
    return 'Payé en ligne';
  }
  return 'Payé';
};

export const getSearchingDriverStatus = (order) => {
  const { pickupStatus, orderFlowType, orderType, status, cancellation } = order
  let { statusLabel } = order
  if (!cancellation && pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED && orderFlowType === ORDER_FLOW_TYPE.REVERSE && orderType === ORDER_TYPE_DELIVERY && status === ORDER_PHASE_CONTACTING) {
    statusLabel = ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL
  }
  return statusLabel;
}


